module.exports = __webpack_public_path__ + "h5/img/dfh@3x.cd4e9278.png";